import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

//const Login = () => import('@/views/Login') to allow cloak to work, so we don't see a flash of the sidebar when we refresh the login page, this isn't lazy loaded
import Login from '@/views/Login.vue';
const Home = () => import('@/views/Home')
const Settings = () => import('@/views/Settings')
const Help = () => import('@/views/Help')
const Signup = () => import('@/views/Signup')
const Transfer = () => import('@/views/Transfer')
const Card = () => import('@/views/Card')
const TestCard = () => import('@/views/TestCard')
const Dashboard = () => import('@/views/Dashboard')

Vue.use(Router)

let router = new Router({
  //https://router.vuejs.org/en/essentials/history-mode.html
  mode: 'history', //won't use hashmode URLs, so requires we redirect 404 errors to index.html
  //https://vueschool.io/articles/vuejs-tutorials/vue-js-router-performance/
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { hideNavigation: true }
    },
    {
      path: '/signup/:step',
      name: 'SignupStep',
      component: Signup,
      props: true,
      meta: { hideNavigation: true }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      props: true,
      meta: { hideNavigation: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/transfer',
      name: 'transfer',
      component: Transfer,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/card/:child_customer_id',
      name: 'card_for_customer',
      component: Card,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/card',
      name: 'card',
      component: Card,
      props: true,
      meta: {
        auth: true
      }
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: {
        auth: true
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        auth: true
      }
    },
    {
      path: '/test_card',
      name: 'TestCard',
      component: TestCard,
      meta: {
        auth: true
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/',
      redirect: '/home'
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth))
  {
    var token = to.query.auth_token
    if (token!=null || localStorage.getItem('auth_token')!=null)
    {
      next()
    } else 
    {
      next({
        path: "/login",
      })
    }
  }
  else {
    next()
  }
})

export default router
